const lpadZero = (str: string, cnt: number): String => {
    let c = str;
    for (let i = 0; i < cnt - str.length; i++) {
        c = "0" + c;
    }
    return c;
}

export const getVersionNum = (version: string): number => {
    const tokens = version.split(".");
    if (tokens.length > 2) {
        const major = lpadZero(tokens[0], 4);
        const minor = lpadZero(tokens[1], 4);
        const patch = lpadZero(tokens[2], 4);

        return Number("" + major + minor + patch);
    }
    return 0;
}

export const getAppVersionNum = (media: string): number => {
    let version = "99.99.99";
    if (media === "kt") {
        version = new URLSearchParams(window.location.search).get('version') ?? '99.99.99';
    } else if (media === "skt") {
        const groups = navigator.userAgent.match(/;PASS\/([0-9\.]+)/);
        version = groups && groups.length > 1 ? groups[1] : '99.99.99';
    }

    return getVersionNum(version);
}
